 const userRole  ={
    Annotator: 1,
    Reviewer:2,
    SuperChecker:3,
    WorkspaceManager:4,
    OrganizationOwner:5,
    Admin:6,
    
 }
export default userRole;